import { useState, useRef } from "react";

import { toast } from "react-toastify";

import apiService from "../services/api";

// Long-press → context menu behaviour for poster cards (movies/series).
// Returns press handlers, the open item, and a favorite toggle. When `enabled`
// is false the press handlers no-op, so a normal click just runs goToDetail.
export default function useFavoritesCardMenu({
  enabled,
  mediaTypeOf,
  goToDetail,
}) {
  const [contextMenuItem, setContextMenuItem] = useState(null);
  const [bookmarkedItems, setBookmarkedItems] = useState({});
  const timerRef = useRef(null);
  const firedRef = useRef(false);

  const keyOf = (item) => item.mediaId || item.id || item.stream_id;

  const startPress = (item) => {
    if (!enabled) return;
    firedRef.current = false;
    timerRef.current = setTimeout(() => {
      firedRef.current = true;
      if (navigator.vibrate) navigator.vibrate(50);
      setContextMenuItem(item);
    }, 500);
  };

  const endPress = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  const handleCardClick = (item) => {
    if (firedRef.current) {
      firedRef.current = false;

      return;
    }
    goToDetail(item);
  };

  const isFav = (item) => {
    const k = keyOf(item);

    return bookmarkedItems[k] !== undefined
      ? bookmarkedItems[k]
      : item.isBookmarked;
  };

  const toggleFavorite = async (item) => {
    const k = keyOf(item);
    const mediaId = String(
      item.mediaId && item.mediaId !== -1
        ? item.mediaId
        : item.tmdbId || item.id
    );
    const mediaType = mediaTypeOf(item);
    const currentlyFav = isFav(item);

    try {
      if (currentlyFav) {
        await apiService.webPlayerDeleteBookmark(mediaId, mediaType);
        setBookmarkedItems((p) => ({ ...p, [k]: false }));
        toast.success("Removed from favorites");
      } else {
        await apiService.webPlayerCreateBookmark(mediaId, mediaType);
        setBookmarkedItems((p) => ({ ...p, [k]: true }));
        toast.success("Added to favorites");
      }
    } catch (error) {
      console.error("Favorite toggle failed:", error);
      toast.error("Failed to update favorites");
    }
  };

  const markAsWatched = async (item) => {
    const mediaId = String(
      item.mediaId && item.mediaId !== -1
        ? item.mediaId
        : item.tmdbId || item.id
    );

    try {
      await apiService.webPlayerMarkAsWatched(mediaId, mediaTypeOf(item));
      toast.success("Marked as watched");
    } catch (error) {
      console.error("Mark as watched failed:", error);
      toast.error("Failed to mark as watched");
    }
  };

  return {
    contextMenuItem,
    markAsWatched,
    setContextMenuItem,
    startPress,
    endPress,
    handleCardClick,
    isFav,
    toggleFavorite,
  };
}
